import React from "react";
import styled from "styled-components";
import { VideoResult } from "common/video/dto/VideoResult";
import VideoSingleNav from "components/common/video/VideoSingleNav";
import VideoPlay from "components/common/video/VideoPlay";
import { staticContentPath } from "common/static_content_common";

type VideoReadProps = {
  video: VideoResult;
};

const VideoRead = ({ video }: VideoReadProps) => {
  return (
    <div>
      <DivField>{video.datum.toDateString()}</DivField>
      <DivField>{video.title}</DivField>
      <DivField>
        {video.fileName && (
          <VideoPlay
            filePath={staticContentPath(video.fileName)}
            autoPlay={false}
            muted={true}
            width={500}
          />
        )}
      </DivField>

      <DivNav>
        <VideoSingleNav video={video} hideReadNav={true} />
      </DivNav>
    </div>
  );
};

const DivField = styled.div`
  margin-top: 0.5rem;
  font-size: 1.2rem;

  &&&:first-of-type {
    margin-top: 0rem;
  }
`;

const DivNav = styled.div`
  margin-top: 1.5rem;
`;

export default VideoRead;
